export const datetimeFormats = {
    "en": {
        long: {
            year: "numeric",
            month: "long",
            day: "numeric",
        }
    },
    "fr": {
        long: {
            year: "numeric",
            month: "long",
            day: "numeric",
        }
    },
} as const